import { Div, A } from 'alkali'
import NotesModel from 'components/extract/model/NotesModel'
import NoteRow from 'components/extract/NoteComponent'

/**
 * Interface for managing study-level notes (StudyLevel qualitative note rows)
 */
export default class NotesMgmtTable extends Div('.notes-table') {
	private notesModel: NotesModel

	created(props) {
		const { notesModel } = props
		const showDelete = notesModel.noteRows.to(rows => rows.some(r => !r.existing))
		props.content = [
			Div('.note-rows', notesModel.noteRows.map(row => new NoteRow({ row, rows: notesModel.noteRows, showDelete }))),
			Div('.op-cell', [
				A('.op-link', {
					onclick: e => {
						this.addNote()
						return false
					}
				}, 'Add Note')
			])
		]
	}

	addNote() {
		this.notesModel.addNote()
	}
}